// 引入element-ui
import element_ul from "element-ui";
// 引入公共的CSS文件
import common_css from "../src/static/css/common.css";
import icon from "../src/static/css/iconfont/iconfont.css";
import "../src/static/css/element-ui/theme/index.css";
import Vue from "vue";
import App from "./App";

import VueWorker from "vue-worker";
Vue.use(VueWorker);
// 引入swiper
import VueAwesomeSwiper from "vue-awesome-swiper";

Vue.use(VueAwesomeSwiper);
// 引入swipecss文件
import swiper_css from "../src/static/css/swiper.css";
//引入element样式
import "element-ui/lib/theme-chalk/base.css";
if (process.env.NODE_ENV == "development") {
	console.log("=== u are development ====");
}

Vue.use(swiper_css);
Vue.use(element_ul);
Vue.use(icon);
Vue.use(common_css);
Vue.config.productionTip = false;

// 引入vuex状态控制文件
import store from "../src/store/index.js";

import router from "./router";
import iconfont from "./static/iconfont/iconfont.css";
Vue.use(iconfont);
window.eventBus = new Vue();

export default new Vue({
	el: "#app",
	router,
	store,
	components: { App },
	template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js